var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_81993",
    "data-name": "Group 81993"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26610",
    "data-name": "Rectangle 26610",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26611",
    "data-name": "Rectangle 26611",
    width: 20,
    height: 19.87,
    transform: "translate(2 2.05)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81992",
    "data-name": "Group 81992",
    transform: "translate(13.787 4.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65552",
    "data-name": "Path 65552",
    d: "M15.869,5.041a.432.432,0,0,1-.19-.047,6.08,6.08,0,0,0-.711-.332c-.1-.038-.209-.085-.313-.123a.393.393,0,1,1,.265-.74c.114.038.237.085.351.133.265.114.531.237.787.37a.393.393,0,0,1,.161.531A.4.4,0,0,1,15.869,5.041Z",
    transform: "translate(-13.675 -3.774)",
    fill: "#c4c4c4",
    stroke: "#c4c4c4",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65553",
    "data-name": "Path 65553",
    d: "M19.81,9.741a.408.408,0,0,1-.379-.275,7.914,7.914,0,0,0-.559-1.346.392.392,0,0,1,.692-.37,8.531,8.531,0,0,1,.626,1.488.4.4,0,0,1-.265.493.476.476,0,0,1-.114.019ZM18.359,7.058a.386.386,0,0,1-.3-.142,7.6,7.6,0,0,0-1.033-1.033.392.392,0,0,1-.057-.55.4.4,0,0,1,.559-.057,8.67,8.67,0,0,1,1.147,1.138.382.382,0,0,1-.057.55.409.409,0,0,1-.247.085Z",
    transform: "translate(-13.804 -3.847)",
    fill: "#c4c4c4",
    stroke: "#c4c4c4",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65554",
    "data-name": "Path 65554",
    d: "M16.658,18.819a.413.413,0,0,1-.332-.171.4.4,0,0,1,.1-.55,7.64,7.64,0,0,0,1.128-.929.4.4,0,0,1,.559,0,.392.392,0,0,1,0,.559,8.656,8.656,0,0,1-1.242,1.033.369.369,0,0,1-.218.066Zm2.162-2.171a.369.369,0,0,1-.218-.066.4.4,0,0,1-.114-.54,7.288,7.288,0,0,0,.683-1.289.394.394,0,0,1,.73.294,8.89,8.89,0,0,1-.759,1.422.4.4,0,0,1-.332.18Zm1.166-2.825H19.91a.393.393,0,0,1-.313-.465,7.188,7.188,0,0,0,.142-1.432,6.331,6.331,0,0,0-.038-.74.387.387,0,0,1,.351-.427.407.407,0,0,1,.436.351,7.7,7.7,0,0,1,.038.815,8.072,8.072,0,0,1-.152,1.583A.387.387,0,0,1,19.986,13.822Z",
    transform: "translate(-13.772 -4.137)",
    fill: "#c4c4c4",
    stroke: "#c4c4c4",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65555",
    "data-name": "Path 65555",
    d: "M14.029,20.367a.39.39,0,0,1-.095-.768,7.441,7.441,0,0,0,1.071-.351.4.4,0,0,1,.521.209.39.39,0,0,1-.209.512,7.868,7.868,0,0,1-1.185.389c-.028,0-.066.009-.095.009Z",
    transform: "translate(-13.636 -4.576)",
    fill: "#c4c4c4",
    stroke: "#c4c4c4",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65556",
    "data-name": "Path 65556",
    d: "M11.479,19.643a8.177,8.177,0,1,1,0-16.353.386.386,0,1,1,0,.771,7.4,7.4,0,1,0,0,14.8.386.386,0,1,1,0,.771Z",
    transform: "translate(0.328 0.445)",
    fill: "#606060",
    stroke: "#606060",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65557",
    "data-name": "Path 65557",
    d: "M11.629,7.411a.64.64,0,0,1-.466-.21.617.617,0,0,1,.045-.871L13,4.737,11.388,2.964a.617.617,0,0,1,.045-.871.636.636,0,0,1,.886.045l2.449,2.689L12.049,7.261a.646.646,0,0,1-.421.165Z",
    transform: "translate(-0.837 -0.502)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65558",
    "data-name": "Path 65558",
    d: "M3.221,5.06a.605.605,0,0,1-.311-.085L0,3.167,1.822.271A.591.591,0,0,1,2.628.088a.578.578,0,0,1,.184.805L1.611,2.8,3.518,3.987a.578.578,0,0,1,.184.805.56.56,0,0,1-.494.268Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 12.537, 16.765)",
    fill: "#c4c4c4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnLoad);
export default __webpack_public_path__ + "static/media/_OnLoad.05ca6d301f6138e952a66da0466c4263.svg";
export { ForwardRef as ReactComponent };